<template>
  <div>
    <Header />
    <v-container grid-list-md fluid-admin class="container-style">
      <!-- FILTER/SEARCH -->
      <div class="container-header">
        <span>Admin Profile</span>
      </div>
      <v-layout row wrap>
        <v-flex xs12 class="box-white">
          <v-text-field
            v-model="userProfile.username"
            box
            label="Username">
          </v-text-field>
        </v-flex>
        <v-flex xs6 class="box-white">
          <v-text-field
            v-model="userProfile.first_name"
            box
            label="First Name">
          </v-text-field>
        </v-flex>
        <v-flex xs6 class="box-white">
          <v-text-field
            v-model="userProfile.last_name"
            box
            label="Last Name">
          </v-text-field>
        </v-flex>
        <v-flex xs12 class="box-white">
          <v-text-field
            v-model="userProfile.email"
            box
            label="Email">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
         <v-flex xs12>
           <div>
             <v-toolbar flat color="transparent" class="v-toolbar-button">
               <v-spacer></v-spacer>
               <v-btn class="button-style-blue" @click="submitProfileForm">Update Profile</v-btn>
             </v-toolbar>
           </div>
         </v-flex>
       </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from "vuex";

import Header from '@/components/Header.vue'

export default {
  name: "Home",
  components: {
    Header,
  },
  computed: {
    ...mapState([
      'admin',
    ]),
  },
  data() {
    return {
      userProfile: {
        username: null,
        email: null,
        first_name: null,
        last_name: null
      }
    }
  },
  methods: {
    ...mapActions(['getUserById', 'updateUser']),
    submitProfileForm() {
      this.updateUser(this.userProfile)
        .then(() => {
          this.$toastr('success', 'Profile Updated', 'Success')
        })
        .catch((error) => {
          this.$toastr('error', error.username, 'Error')
        })
    }
  },
  created () {
    if (this.$route.name == "admin-profile") {
      this.getUserById({ id: this.admin.user.id })
        .then((data) => {
          this.userProfile = this.admin.user;
        })
    }
  }
}
</script>
